import { CommonModule } from '@angular/common';
import { Component, computed, input, output, Signal } from '@angular/core';
import { SortDirection } from '@webapp/core/stores/types';
import {
  BadgeComponent,
  IconComponent,
  IconTitleComponent,
  Status,
  UserBadgeComponent,
  IconType,
} from '@webapp/ui';
import { IPolicyRow } from '../../../interfaces/policies.interface';
import { riskIconKey } from '@webapp/risk-core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-policies-table',
  imports: [
    CommonModule,
    UserBadgeComponent,
    BadgeComponent,
    IconComponent,
    IconTitleComponent,
    RouterLink
  ],
  templateUrl: './policies-table.component.html',
  styleUrl: './policies-table.component.scss',
})
export class PoliciesTableComponent {
  entities = input<IPolicyRow[]>([]);
  showUser = input<boolean>(true);
  sortDirection: SortDirection = 'desc';
  showProducer = input<boolean>(true);

  Status = Status;

  viewDetail = output<IPolicyRow>();

  getIconName = (tag: string): IconType => riskIconKey(tag) as IconType;

  get rows(): Signal<IPolicyRow[]> {
    return computed(() => {
      const sortMultiplier = this.sortDirection === 'asc' ? 1 : -1;
      return this.entities().sort(
        (a, b) => (a.internalNumber - b.internalNumber) * sortMultiplier
      );
    });
  }

  toggleSort() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  }

}
